var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      key: _vm.vueKey,
      staticStyle: { "z-index": "10000000 !important" },
      attrs: { persistent: "", width: "300" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { attrs: { color: "primary", dark: "" } },
        [
          _c(
            "v-card-text",
            [
              _vm._v("\n      " + _vm._s(_vm.msg) + "\n      "),
              _c("v-progress-linear", {
                staticClass: "mb-0",
                attrs: { indeterminate: "", color: "white" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }